import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { StoreType } from '@/types/store/store.type';
import { StayStoreType } from '@/types/store/stay-store.type';

const namespaced: boolean = true;
export const stay: Module<StayStoreType, StoreType> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
